/**
 * Created by rhinov12 on 26/11/2015.
 */

/**
 * Timer used for benchmarking function
 * @constructor
 */

declare var cc: any;

export class BenchTimer {

    running: boolean = false;
    startTime: Date | null = null;
    lastTime: Date | null = null;
    fpsValues: Array<number> = [];

    elapsedValues: Array<number> = [];

    constructor () {
        this.running = false;
        this.startTime = null;
        this.lastTime = null;

        this.elapsedValues = []; // Array of elasped values
    }

    startBenchmarkSession() {
        if (this.running) {
            throw (new Error('Timer already started'));
        }
        this.startClock();
        this.elapsedValues = [];
        this.fpsValues = [];
        this.running = true;
    }

    /**
     * Stop this session and return the average ms values
     * @returns {number}
     */
    stopBenchmarkSession(): number {
        var i;
        if (!this.running) {
            throw (new Error('Timer not started'));
        }
        if (this.elapsedValues.length === 0) {
            throw (new Error('No data in bench'));
        }
        this.stopClock();
        this.running = false;
        var averageValue = 0;
        var maxValue = this.elapsedValues[0];
        var minValue = this.elapsedValues[0];
        for (i = 0; i < this.elapsedValues.length; i++) {
            if (this.elapsedValues[i] > maxValue)
                maxValue = this.elapsedValues[i];
            if (this.elapsedValues[i] < minValue)
                minValue = this.elapsedValues[i];
            averageValue += this.elapsedValues[i];
        }
        averageValue = averageValue / this.elapsedValues.length;

        console.log('Bench result : av:' + averageValue + 'ms/minValue:' + minValue + 'ms/maxValue' + maxValue + 'ms');
        for (i = 0; i < this.elapsedValues.length; i++) {
            console.log('------Bench ' + i + ':' + this.elapsedValues[i] + '/' + this.fpsValues[i]);
        }
        console.log('Bench end');
        return averageValue;
    }
    /**
     * Start a bench step
     */
    startBenchStep() {
        if (!this.running) {
            throw (new Error('Timer not started'));
        }
        this.getElapsedTime();
    }
    /**
     * End a bench step
     */
    endBenchStep() {
        if (!this.running) {
            throw (new Error('Timer not started'));
        }
        this.elapsedValues.push(this.getElapsedTime());
        this.fpsValues.push(1.0 / cc.director.getDeltaTime());
    }
    /**
     * Start benchTimer clock
     */
    startClock() {
        this.startTime = new Date();
        this.lastTime = this.startTime;
    }
    /**
     * Stop benchTimer clock
     */
    stopClock() {

    }
    /**
     * Return elapsedtime since last call of this function
     *
     * @returns {number} Elapsed time in ms
     */
    getElapsedTime(): number {
        if (!this.running) {
            throw (new Error('Timer not started'));
        }
        var newTime = new Date();
        var delta = newTime.getTime() - this.lastTime!.getTime();
        this.lastTime = newTime;
        return delta;
    }
    /**
     * Return total elasped time since start of timer
     *
     * @returns {number} Total time in ms
     */
    getTotalTime(): number {
        if (!this.running) {
            throw (new Error('Timer not started'));
        }
        var newTime = new Date();
        return newTime.getTime() - this.startTime!.getTime();
    }


}
